// extracted by css-extract-rspack-plugin
export default {"megatronItem":"k4d1ZAd3iINLEXzs"};